module.exports = __webpack_public_path__ + "static/media/VirgenCoromotoAltar400.efd7ea92.jpg";